import * as i0 from '@angular/core';
import { Directive, Input, HostBinding } from '@angular/core';
let NgDocFocusableDirective = /*#__PURE__*/(() => {
  class NgDocFocusableDirective {
    constructor() {
      this.focusable = true;
    }
    get tabIndex() {
      return this.focusable ? 0 : -1;
    }
    static {
      this.ɵfac = function NgDocFocusableDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocFocusableDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgDocFocusableDirective,
        selectors: [["", "ngDocFocusable", ""]],
        hostVars: 1,
        hostBindings: function NgDocFocusableDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("tabIndex", ctx.tabIndex);
          }
        },
        inputs: {
          focusable: [0, "ngDocFocusable", "focusable"]
        },
        exportAs: ["ngDocFocusable"],
        standalone: true
      });
    }
  }
  return NgDocFocusableDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocFocusableDirective };
